const s = {
  calloutBoxSize: { sizeId: "M" },
  showHeader: !0,
  showLogo: !0,
  showPropertyName: !0,
  showPropertyAddress: !0,
  showMetrics: !0,
  headerContainerColor: "#6FA2CE",
  headerContainerOpacity: 100,
  propertyNameFontFamily: "Open Sans",
  propertyNameFontWeight: 700,
  propertyNameFontSize: 13,
  propertyNameFontColor: "#FFFFFF",
  propertyNameFontOpacity: 100,
  propertyAddressFontFamily: "Open Sans",
  propertyAddressFontWeight: 400,
  propertyAddressFontSize: 11,
  propertyAddressFontColor: "#FFFFFF",
  propertyAddressFontOpacity: 100,
  showMetricsVisits: !0,
  showMetricsVisitsRanking: !1,
  metricsRankShowAs: "rank",
  metricsRankType: "primary.country",
  metricsDisplayAsNA: !0,
  showVisitsFrequency: !1,
  showDwellTime: !1,
  showMetricsVisitsSqFt: !1,
  showMetricsVisitors: !1,
  showSales: !1,
  showTransactions: !1,
  showSalesSqFt: !1,
  showAverageTicketSize: !1,
  showCensusMedianHouseholdIncome: !1,
  showCensusAverageHouseholdIncome: !1,
  showCensusPopulation: !1,
  showCensusHousehold: !1,
  showCensusPopulationDensity: !1,
  showCensusMedianAge: !1,
  showCensusPersonsPerHousehold: !1,
  showPopstatsMedianHouseholdIncome: !1,
  showPopstatsAverageHouseholdIncome: !1,
  showPopstatsPopulation: !1,
  showPopstatsHousehold: !1,
  showPopstatsPopulationDensity: !1,
  showPopstatsMedianAge: !1,
  showPopstatsPopGrowth2123: !1,
  showPopstatsPopGrowth2328: !1,
  showPopstatsPopProjection28: !1,
  showPopstatsPersonsPerHousehold: !1,
  showPopstatsPercentCollegeDegree: !1,
  showPredominantMosaicSegment: !1,
  showPredominantPersonaLiveSegment: !1,
  showResidentPopulation: !1,
  showEmployeesPopulation: !1,
  showDaytimePopulation: !1,
  showMarketsCensusMedianHouseholdIncome: !1,
  showMarketsCensusAverageHouseholdIncome: !1,
  showMarketsCensusPopulation: !1,
  showMarketsCensusHousehold: !1,
  showMarketsCensusPopulationDensity: !1,
  showMarketsCensusMedianAge: !1,
  showMarketsPopstatsMedianHouseholdIncome: !1,
  showMarketsPopstatsAverageHouseholdIncome: !1,
  showMarketsPopstatsPopulation: !1,
  showMarketsPopstatsHousehold: !1,
  showMarketsPopstatsPopulationDensity: !1,
  showMarketsPopstatsMedianAge: !1,
  showOutOfMarketVisitors: !1,
  showOutOfMarketVisits: !1,
  showMarketsVisitFrequency: !1,
  showMarketsAvgDwellTime: !1,
  showMarketsMedianDwellTime: !1,
  showMarketsEmployeesWorkforce: !1,
  showMarketsPercentWhiteCollar: !1,
  showMarketsVisitsByEmployees: !1,
  showMarketsMedianSalary: !1,
  showMarketsInboundCommuters: !1,
  showMarketsNumBusinesses: !1
}, e = {
  showCensusMedianHouseholdIncome: !1,
  showCensusAverageHouseholdIncome: !1,
  showCensusPopulation: !1,
  showCensusHousehold: !1,
  showCensusPopulationDensity: !1,
  showCensusMedianAge: !1,
  showCensusPersonsPerHousehold: !1,
  showPopstatsMedianHouseholdIncome: !1,
  showPopstatsAverageHouseholdIncome: !1,
  showPopstatsPopulation: !1,
  showPopstatsHousehold: !1,
  showPopstatsPopulationDensity: !1,
  showPopstatsMedianAge: !1,
  showPopstatsPopGrowth2123: !1,
  showPopstatsPopGrowth2328: !1,
  showPopstatsPopProjection28: !1,
  showPopstatsPersonsPerHousehold: !1,
  showPopstatsPercentCollegeDegree: !1,
  showPredominantMosaicSegment: !1,
  showPredominantPersonaLiveSegment: !1
}, o = {
  showResidentPopulation: !1,
  showEmployeesPopulation: !1,
  showDaytimePopulation: !1,
  showMarketsCensusMedianHouseholdIncome: !1,
  showMarketsCensusAverageHouseholdIncome: !1,
  showMarketsCensusPopulation: !1,
  showMarketsCensusHousehold: !1,
  showMarketsCensusPopulationDensity: !1,
  showMarketsCensusMedianAge: !1,
  showMarketsPopstatsMedianHouseholdIncome: !1,
  showMarketsPopstatsAverageHouseholdIncome: !1,
  showMarketsPopstatsPopulation: !1,
  showMarketsPopstatsHousehold: !1,
  showMarketsPopstatsPopulationDensity: !1,
  showMarketsPopstatsMedianAge: !1,
  showOutOfMarketVisitors: !1,
  showOutOfMarketVisits: !1,
  showMarketsVisitFrequency: !1,
  showMarketsAvgDwellTime: !1,
  showMarketsMedianDwellTime: !1,
  showMarketsEmployeesWorkforce: !1,
  showMarketsPercentWhiteCollar: !1,
  showMarketsVisitsByEmployees: !1,
  showMarketsMedianSalary: !1,
  showMarketsInboundCommuters: !1,
  showMarketsNumBusinesses: !1
}, a = {
  showMetricsVisitors: !1,
  showMetricsVisitsSqFt: !1,
  showVisitsFrequency: !1,
  showDwellTime: !1,
  ...e,
  ...o
}, t = 8, l = 4, r = {
  calloutBoxSize: { sizeId: "M" },
  showHeader: !1,
  showLogo: !0,
  showPropertyName: !1,
  showPropertyAddress: !1,
  showMetrics: !1,
  headerContainerColor: "#6FA2CE",
  headerContainerOpacity: 100,
  propertyNameFontFamily: "Open Sans",
  propertyNameFontWeight: 700,
  propertyNameFontSize: 13,
  propertyNameFontColor: "#FFFFFF",
  propertyNameFontOpacity: 100,
  propertyAddressFontFamily: "Open Sans",
  propertyAddressFontWeight: 400,
  propertyAddressFontSize: 11,
  propertyAddressFontColor: "#FFFFFF",
  propertyAddressFontOpacity: 100,
  showMetricsVisits: !0,
  showMetricsVisitsRanking: !1,
  metricsRankShowAs: "rank",
  metricsRankType: "primary.country",
  metricsDisplayAsNA: !0,
  showMetricsVisitors: !1,
  showVisitsFrequency: !1,
  showDwellTime: !1,
  showMetricsVisitsSqFt: !1,
  showSales: !1,
  showTransactions: !1,
  showSalesSqFt: !1,
  showAverageTicketSize: !1,
  showCensusMedianHouseholdIncome: !1,
  showCensusAverageHouseholdIncome: !1,
  showCensusPopulation: !1,
  showCensusHousehold: !1,
  showCensusPopulationDensity: !1,
  showCensusMedianAge: !1,
  showCensusPersonsPerHousehold: !1,
  showPopstatsMedianHouseholdIncome: !1,
  showPopstatsAverageHouseholdIncome: !1,
  showPopstatsPopulation: !1,
  showPopstatsHousehold: !1,
  showPopstatsPopulationDensity: !1,
  showPopstatsMedianAge: !1,
  showPopstatsPopGrowth2123: !1,
  showPopstatsPopGrowth2328: !1,
  showPopstatsPopProjection28: !1,
  showPopstatsPersonsPerHousehold: !1,
  showPopstatsPercentCollegeDegree: !1,
  showPredominantMosaicSegment: !1,
  showPredominantPersonaLiveSegment: !1,
  showResidentPopulation: !1,
  showEmployeesPopulation: !1,
  showDaytimePopulation: !1,
  showMarketsCensusMedianHouseholdIncome: !1,
  showMarketsCensusAverageHouseholdIncome: !1,
  showMarketsCensusPopulation: !1,
  showMarketsCensusHousehold: !1,
  showMarketsCensusPopulationDensity: !1,
  showMarketsCensusMedianAge: !1,
  showMarketsPopstatsMedianHouseholdIncome: !1,
  showMarketsPopstatsAverageHouseholdIncome: !1,
  showMarketsPopstatsPopulation: !1,
  showMarketsPopstatsHousehold: !1,
  showMarketsPopstatsPopulationDensity: !1,
  showMarketsPopstatsMedianAge: !1,
  showOutOfMarketVisitors: !1,
  showOutOfMarketVisits: !1,
  showMarketsVisitFrequency: !1,
  showMarketsAvgDwellTime: !1,
  showMarketsMedianDwellTime: !1,
  showMarketsEmployeesWorkforce: !1,
  showMarketsPercentWhiteCollar: !1,
  showMarketsVisitsByEmployees: !1,
  showMarketsMedianSalary: !1,
  showMarketsInboundCommuters: !1,
  showMarketsNumBusinesses: !1
}, n = {
  date_preset: "last-12-months",
  sort_by: "foot_traffic",
  includeTenants: !0,
  populationStatsConfig: {
    dataset: "popstats",
    tradeAreaType: "TTA",
    visitsPercent: 70,
    distance: 50
  },
  marketsStatsConfig: {
    dataset: "popstats",
    demographicsAudience: "any_resident",
    workforceAudience: "any_worker",
    visitsAudience: ["inbound_visitor"]
  }
}, i = {
  isGrouped: !0,
  metricsInitiallyLoading: !0,
  poiCalloutBoxConfig: s,
  // Having undefined as initial value makes the
  // renderer use the default list of logos.
  poiCalloutBoxLogosList: void 0,
  offsetMap: {}
};
export {
  t as MAXIMUM_CONCURRENT_ADDITIONAL_METRICS_POIS,
  l as MAXIMUM_METRICS_IN_POI,
  n as POICalloutDefaultFetchFilter,
  i as POICalloutDefaultVisualFilter,
  s as defaultPOICalloutBoxConfig,
  r as defaultThumbnailConfig,
  a as disabledAdditionalMetrics,
  e as disabledDemographicMetrics
};
//# sourceMappingURL=index.es74.js.map
